import { render, staticRenderFns } from "./ClassTimetable.vue?vue&type=template&id=8911f2f0"
import script from "./ClassTimetable.vue?vue&type=script&lang=js"
export * from "./ClassTimetable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports